/* eslint-disable multiline-ternary */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

const config = {
  types: [],
  modifiers: [
    {
      title: 'default',
      isDefault: true
    },
    'inverse'
  ],
  states: []
}

const Spinner = (props) => {
  const { isLoading, inverse } = props
  const [loading] = useState(!!isLoading)

  return loading ? (
    <div className={resolveProps(props, config, 'Spinner')}>
      <span className="mdn-Icon-claro mdn-Icon--lg" />
    </div>
  ) : (
    ''
  )
}
export default Spinner

Spinner.propTypes = {
  isLoading: PropTypes.bool,
  inverse: PropTypes.bool
}
